import("../src/javascripts/attachments-redesign");
import("../src/javascripts/navigation");
import("../src/javascripts/easy-toggle");
import("../src/javascripts/slider_splide");
import("../src/javascripts/smooth-scroll-to-anchor");

$(document).ready(function () {
  const speed = 150;

  $(".Button--services-tab[data-industry='ml & ai frameworks']").addClass("active");
  $(".GridPresenter--industry").hide();
  $(".GridPresenter--industry[data-industry='ml & ai frameworks']").show();

  $(".Button--services-tab").on("click", function () {
    if ($(this).hasClass("active")) return;

    const industryType = $(this).data("industry");
    const $tabs = $(".GridPresenter--industry");

    $(`.Button--services-tab`).removeClass("active");
    $(this).addClass("active");

    $tabs.fadeOut(speed);
    industryType === "all" ? $tabs.fadeIn(speed) : $(`.GridPresenter--industry[data-industry="${industryType}"]`).fadeIn(speed);
  });
});
